export const gitCommit = '73eefd59'
